export default __webpack_public_path__ + "static/tutorials-watershed-c7b207e3d93bc7c2e3e599bac6141b60.png";